import React from 'react';
import classNames from 'classnames';
import styles from './auth-page.module.scss';
import { autoId } from '@workday/upc-common';

export interface AuthPageProps {
    children: React.ReactNode;
    header?: React.ReactElement;
    className?: string;
    /**
     * @deprecated The pageId property is deprecated and should not be used. If you really need an autoId on
     * this component then just use the autoId function on the component, like everywhere else.
     */
    pageId?: string;
    footer?: React.ReactElement;
}

export const AuthPage = ({ children, header, footer, className, pageId, ...rest }: AuthPageProps) => {
    const classes = classNames(styles.authPage, className);

    return (
        <div {...autoId(pageId)} className={classes} {...rest}>
            {header}
            <main className={styles.content}>{children}</main>
            {footer}
        </div>
    );
};
